<script>
  import { user } from "../../firebase";
  import { router } from "tinro";
  import Assignees from "../../components/assignees.svelte";
  import Preview from "./Preview.svelte";
  import AttachmentDisplay from "./attachmentsDisplay.svelte";
  import { conversion, lang } from "../../store/store";
  import {
    format,
    endOfDay,
    addDays,
    addBusinessDays,
    startOfTomorrow,
    startOfToday,
    getDay,
  } from "date-fns";
  export let TaskRef;
  export let userTasks;
  let date = format(new Date(parseInt(userTasks.date_created)), "MMM d, uuu");
  let userinfo;
  $user.doc.subscribe((v) => {
    userinfo = v;
  });
  let active = [];
  let project = userTasks;
  console.log(project.assignees);
  $: console.log("YES CHANGED HERE", userTasks);
  let description = userTasks.description;
  let attachments = userTasks.attachements;
  console.log("attachments");
  console.log(attachments);
  let expand = false;
  let preview = "";
  let rest;
  let MAXESTIMATIONDAY;
  if (userTasks?.estimation?.maxDel) {
    let maxEstimation = userTasks.estimation.maxDel;

    MAXESTIMATIONDAY = format(
      addBusinessDays(startOfTomorrow(), maxEstimation - 1),
      "yyyy-MM-dd"
    );
  }

  let sliced = true;
  function readomore() {
    sliced = false;
  }
  function readless() {
    sliced = true;
  }

  // CLEAN PARAGRAPHS

  console.log("---------------------- TESTING PHASE ----------------------");
  let testParah = userTasks.description;
  let newStr1 = testParah.replace("<p>", "");
  let newStr = newStr1.replace("</p>", "");
  console.log(newStr);
</script>

<!-- YASSINE -->

{#if preview}
  <Preview bind:preview />
{/if}
{#if userTasks}
  <div class="contentWrapper">
    <div class="row">
      <div style="margin-right:3rem;" class="column">
        <h5 class="taskID_title">
          {$conversion[$lang].SingleTask.TaskDescription[1]}
        </h5>
        <h4 class="taskID">{TaskRef}</h4>
      </div>
      <div class="column">
        <h5 class="taskID_title">
          {$conversion[$lang].SingleTask.TaskDescription[9]}
        </h5>
        <h4 class="taskID">{userTasks.name}</h4>
      </div>
    </div>
    <h4 class="descriptionTitle">
      {$conversion[$lang].SingleTask.TaskDescription[2]}
    </h4>
    <!-- <div style="position:relative">
      {#if description.length > 235}
        <span class:expand class="description_text ">
          {#if !expand}
            <div
              on:click={() => {
                expand = true;
              }}
              class="rd-more">
              Read more
            </div>
          {/if}
          {@html description}
        </span>
      {:else}
        <span class:expand class="description_text ">
          {@html description}
        </span>
      {/if}
    </div> -->
    <!-- this is description -->

    <p class="__description">
      {#if sliced}
        {newStr.slice(0, 120)}
        {#if newStr.length > 235}
          ...
          <span on:click={readomore} class="ReadMoreSpan"
            >{$conversion[$lang].ApproveComponent[11]}</span
          >
        {/if}
      {:else}
        {newStr.slice(0, newStr.length)}
        <span on:click={readless} class="ReadMoreSpan"
          >{$conversion[$lang].ApproveComponent[12]}</span
        >
      {/if}
    </p>

    <div class="clientContainer">
      <div class="clientContainer_left">
        <h5 class="taskID_title">
          {$conversion[$lang].SingleTask.TaskDescription[3]}
        </h5>
        <div class="clientInfo">
          <div class="u-img"><img src={userinfo.account.img} alt="" /></div>
          <div>{userinfo.account.firstname} {userinfo.account.lastname}</div>
        </div>
      </div>
      <!--
      <div class="clientContainer_right">
        <h5 class="taskID_title">Assignees</h5>
        <Assignees bind:active bind:project />
      </div>-->
    </div>

    <div class="prioritySection">
      <div class="leftside">
        <div class="_leftsideText">
          <h5 class="taskID_title">
            {$conversion[$lang].SingleTask.TaskDescription[5]}
          </h5>
        </div>
        {#if userTasks.priority}
          <div
            style="color:var(--priority{userTasks.priority.name})"
            class="priorityContainer"
          >
            <div
              style={userTasks.priority.name == "low"
                ? "transform:rotate(180deg)"
                : ""}
              class="arrow"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  style="fill:var(--priority{userTasks.priority.name})"
                  d="M8.92017 0.209705L9.0438 0.292893L15.6052 5.29289C16.1177 5.68342 16.1177 6.31658 15.6052 6.70711C15.1321 7.06759 14.3878 7.09532 13.873 6.7903L13.7494 6.70711L9.42815 3.415V15C9.42815 15.5523 8.84063 16 8.11587 16C7.44289 16 6.88822 15.614 6.81242 15.1166L6.80359 15V3.415L2.48239 6.70711C2.00933 7.06759 1.26497 7.09532 0.750172 6.7903L0.626546 6.70711C0.153489 6.34662 0.117101 5.77939 0.517379 5.3871L0.626546 5.29289L7.18795 0.292893C7.66101 -0.0675907 8.40537 -0.0953203 8.92017 0.209705Z"
                />
              </svg>
            </div>
            <h5>{userTasks.priority.name}</h5>
          </div>
        {/if}
      </div>
      <div class="rightSide">
        <div class="_rightsideText">
          <h5 class="taskID_title">
            {$conversion[$lang].SingleTask.TaskDescription[6]}
          </h5>
        </div>
        <div class="statusValue">
          <div class="textContainer">
            <h5>{userTasks.status.status}</h5>
          </div>
        </div>
      </div>
      {#if MAXESTIMATIONDAY}
        <div class="FullrightSide">
          <h5 class="taskID_title">
            {$conversion[$lang].SingleTask.TaskDescription[7]}
          </h5>
          {#if MAXESTIMATIONDAY}
            <h5 class="deadlineValue">{MAXESTIMATIONDAY}</h5>
          {/if}
        </div>
      {/if}
    </div>

    <div class="created_at">
      <i class="bx bxs-calendar-alt" />
      <h5>{date}</h5>
    </div>

    {#if Object.keys(attachments).length !== 0}
      <h4 class="descriptionTitle">
        {$conversion[$lang].SingleTask.TaskDescription[8]}
      </h4>
      <div class="attachment-ctn">
        {#each Object.entries(attachments) as [id, attachment]}
          <AttachmentDisplay bind:attachment bind:preview />
        {:else}
          <div>no attachments</div>
        {/each}
      </div>
    {/if}
  </div>
{/if}

<style>
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
    border-radius: 10px;
  }

  .attachment-ctn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    max-height: 135px;
  }
  .contentWrapper {
    /* background-color: black; */
    padding: 1rem;
  }

  * {
    padding: 0;
    margin: 0;
  }

  .taskID_title {
    color: #91929e;
    font-weight: 400;
  }

  .taskID {
    font-weight: 500;
  }

  .description_text {
    white-space: pre-line;
    display: inline;
    width: 85%;
    font-size: 0.9em;
    margin-bottom: 1rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .description_text.expand {
    -webkit-line-clamp: unset;
    padding-right: 0;
  }

  .rd-more {
    position: absolute;
    font-size: 0.9em;
    bottom: 0px;
    right: 15px;
    color: #2c8f73;
    cursor: pointer;
  }

  .descriptionTitle {
    margin-top: 0.5rem;
  }

  .clientContainer {
    display: flex;
    /* background: red; */
    margin-bottom: 3rem;
  }

  .clientContainer_left {
    /* background: grey; */
    margin-right: 1.5rem;
  }

  .clientContainer_right {
    display: flex;
    flex-direction: column;
  }

  .clientInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1em;
  }

  .prioritySection {
    display: flex;
    flex-direction: row;
  }

  .PriorityValue,
  .statusValue {
    display: flex;
    flex-direction: row;
  }

  .statusValue {
    border-radius: 12px;
  }

  .textContainer {
    background: #e0f9f2;
    color: #00d097;
    border-radius: 0.5rem;
  }

  .textContainer h5 {
    padding: 0.5rem;
    text-transform: capitalize;
  }

  .deadlineValue {
    font-weight: 500;
    font-size: 1em;
    margin-bottom: 1rem;
  }

  .created_at {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .created_at i {
    font-size: 1.3em;
    color: #7d8592;
    margin-right: 0.5rem;
  }

  .created_at h5 {
    font-size: 0.8em;
    color: #7d8592;
    font-weight: 400;
  }

  .u-img {
    border-radius: 50%;
    display: flex;
    width: 2rem;
    height: 2rem;
    overflow: hidden;
    margin-right: 0.6rem;
  }

  .arrow {
    height: 25px;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
  }

  .priorityContainer {
    padding: 0.5rem 0;
    display: flex;
    color: #ffbd21;
    text-transform: capitalize;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .rightSide {
    margin-left: 4rem;
  }

  .FullrightSide {
    margin-left: 4rem;
  }

  .__description span {
    color: #04a9f4;
  }

  .__description {
    font-size: 0.9em;
    margin-bottom: 1rem;
  }

  @media only screen and (max-width: 1100px) {
  }
</style>
